'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var howItWorks = exports.howItWorks = {
  title: 'Cómo funciona',
  description: 'Tu plataforma para aprender lo que quieras a través de videoformación',
  background_url: 'https://dev-res.thumbr.io/images/howitworks-banner.jpg',
  learn_title: 'Aprende',
  learn_description: 'Encuentra lo que necesitas entre más de 60.000 videocursos. De todas las temáticas y niveles. Aprende a tu ritmo y junto a miles de compañeros de aula, que te ayudarán en lo que necesites.',
  learn_image: 'https://dev-res.thumbr.io/images/howitworks-learn-section.jpg',
  teach_title: 'Enseña',
  teach_description: 'Demuestra tus habilidades y crea tu propio curso. Lo grabas, lo subes y empiezas a ganar dinero, así de fácil. Tienes millones de personas deseando aprender, ¿te ves capaz de enseñarnos?',
  teach_image: 'https://dev-res.thumbr.io/images/howitworks-teach-section.png',
  promote_title: 'Promueve',
  promote_description: 'También puedes ganar dinero promoviendo los cursos de otros. Hazte Afiliado y aprende a promocionar contenido de terceros por Redes Sociales, Webs e incluso canales offline.',
  promote_image: 'https://dev-res.thumbr.io/images/howitworks-promote-section.png',
  tech_title: 'Unimos <b>Producto y Tecnología</b> en una plataforma diseñada para tí',
  tech_image: 'https://dev-res.thumbr.io/images/howitworks-tech-section.png',
  tech_products_title: 'Distintos productos hechos a tu medida',
  tech_products_description: 'Encuentra lo que mejor se adapte a tu estilo: Cursos, Suscripciones o Títulos universitarios. Tú decides.',
  tech_multiple_title: 'Múltiples servicios para que aprendas mejor',
  tech_multiple_description: 'Cuadernos, Notas, Preguntas, Proyectos, Grupos, Tutores... lo que quieras para que tu experiencia sea genial.',
  tech_cta: 'Regístrate, es gratis'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/how_it_work.js
// module id = 700
// module chunks = 0